// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf15';
    else rules += ' _Le15';
    if (props.isStaticColor) rules += ' Oe15';
    else rules += ' Oh15';
    rules += ' OlOVIhfcebS7sd15';
    rules += ' OlOVIhfcebS7sd15';
    rules += ' _Mc15';
    rules += ' _Kd15';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr15';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s15';
    rules += ' oR3ltQc15';
    rules += ' nR3ltQc15';
    rules += ' kR3ltQc15';
    rules += ' jR3ltQc15';
    if (props.isStandalone) {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c15';
        rules += ' vFHT6Dd15';
    }
    if (props.isStandalone) {
        rules += ' xc15';
        rules += ' _xa15';
    }
    if (props.isStandalone) {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    }
    if (props.isStaticColor) rules += ' pl15';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po15';
        else if (props.isFocusVisible) rules += ' po15';
        else if (props.isHovered) rules += ' po15';
        else rules += ' pt15';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps15';
        else if (props.isFocusVisible) rules += ' ps15';
        else if (props.isHovered) rules += ' ps15';
        else rules += ' pu15';
    }
    rules += ' plOVIhfcA5Qiqd15';
    rules += ' plOVIhfcA5Qiqd15';
    rules += ' Yd15';
    rules += ' Xb15';
    rules += ' _2b15';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb15';
                rules += ' __Va15';
            } else if (props.isHovered) {
                rules += ' _Xb15';
                rules += ' __Va15';
            } else rules += ' _Xa15';
        }
    } else {
        rules += ' _Xb15';
        rules += ' __Va15';
    }
    rules += ' __ca15';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else if (props.size === "L") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else if (props.size === "S") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else if (props.size === "XS") {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    } else {
        rules += ' uk15';
        rules += ' ucJ9TBTb15';
        rules += ' ud3Euai15';
        rules += ' uea15';
        rules += ' ugb15';
        rules += ' uhd15';
        rules += ' uje15';
        rules += ' u2NhKxcl15';
        rules += ' uic15';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e15';
        rules += ' vFHT6Dd15';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d15';
        rules += ' vFHT6Dd15';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b15';
        rules += ' vFHT6Dd15';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a15';
        rules += ' vFHT6Dd15';
    } else {
        rules += ' -_6BNtrc-c15';
        rules += ' vFHT6Dd15';
    }
    if (props.size === "XL") {
        rules += ' xb15';
        rules += ' _xa15';
    } else if (props.size === "L") {
        rules += ' xb15';
        rules += ' _xa15';
    } else if (props.size === "S") {
        rules += ' xb15';
        rules += ' _xa15';
    } else if (props.size === "XS") {
        rules += ' xb15';
        rules += ' _xa15';
    } else {
        rules += ' xb15';
        rules += ' _xa15';
    }
    if (props.size === "XL") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else if (props.size === "L") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else if (props.size === "S") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else if (props.size === "XS") {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    } else {
        rules += ' _Fd15';
        rules += ' _FnuYUweb15';
    }
    if (props.fillStyle === "outline") rules += ' pm15';
    else if (props.fillStyle === "subtle") rules += ' pm15';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg15';
        else if (props.variant === "chartreuse") rules += ' pg15';
        else if (props.variant === "yellow") rules += ' pg15';
        else if (props.variant === "orange") rules += ' pg15';
        else if (props.variant === "notice") rules += ' pg15';
        else rules += ' px15';
    }
    rules += ' sd15';
    rules += ' ea15';
    rules += ' egLWx3bb15';
    rules += ' _oa15';
    rules += ' Sv15';
    rules += ' SgLWx3bd15';
    rules += ' Rv15';
    rules += ' RgLWx3bd15';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc15';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG15';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c15';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc15';
    } else if (!minWidth) rules += ' N4dY0ec15';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec15';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn15';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b15';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd15';
    else rules += ' -SFnbic-_Jb15';
    rules += ' -Bu7z1c-oH5kTnc15';
    rules += ' oj15';
    rules += ' nj15';
    rules += ' kj15';
    rules += ' jj15';
    rules += ' qc15';
    rules += ' qsd15';
    rules += ' -Qg41Lb-IAxCW0c15';
    rules += ' -Qg41Lb-gLWx3bIYB8I15';
    rules += ' MAyFGYc15';
    rules += ' Td15';
    rules += ' Qd15';
    rules += ' -aRvJDd-Tu7Fubd15';
    rules += ' _Ca15';
    if (props.fillStyle === "outline") rules += ' g_g15';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f15';
        else if (props.variant === "cinnamon") rules += ' gP15';
        else if (props.variant === "brown") rules += ' gO15';
        else if (props.variant === "turquoise") rules += ' gy15';
        else if (props.variant === "pink") rules += ' gT15';
        else if (props.variant === "magenta") rules += ' gS15';
        else if (props.variant === "fuchsia") rules += ' gR15';
        else if (props.variant === "purple") rules += ' gM15';
        else if (props.variant === "indigo") rules += ' gK15';
        else if (props.variant === "blue") rules += ' gG15';
        else if (props.variant === "cyan") rules += ' gC15';
        else if (props.variant === "seafoam") rules += ' gz15';
        else if (props.variant === "green") rules += ' gA15';
        else if (props.variant === "celery") rules += ' gv15';
        else if (props.variant === "chartreuse") rules += ' gJ15';
        else if (props.variant === "yellow") rules += ' gW15';
        else if (props.variant === "orange") rules += ' gV15';
        else if (props.variant === "red") rules += ' gU15';
        else if (props.variant === "gray") rules += ' gI15';
        else if (props.variant === "negative") rules += ' gU15';
        else if (props.variant === "notice") rules += ' gV15';
        else if (props.variant === "positive") rules += ' gA15';
        else if (props.variant === "neutral") rules += ' gI15';
        else if (props.variant === "informative") rules += ' gG15';
        else if (props.variant === "accent") rules += ' gG15';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm15';
        else if (props.variant === "cinnamon") rules += ' gq15';
        else if (props.variant === "brown") rules += ' gn15';
        else if (props.variant === "turquoise") rules += ' g515';
        else if (props.variant === "pink") rules += ' gx15';
        else if (props.variant === "magenta") rules += ' gD15';
        else if (props.variant === "fuchsia") rules += ' gr15';
        else if (props.variant === "purple") rules += ' go15';
        else if (props.variant === "indigo") rules += ' gl15';
        else if (props.variant === "blue") rules += ' g215';
        else if (props.variant === "cyan") rules += ' gk15';
        else if (props.variant === "seafoam") rules += ' g415';
        else if (props.variant === "green") rules += ' g115';
        else if (props.variant === "celery") rules += ' g715';
        else if (props.variant === "chartreuse") rules += ' gp15';
        else if (props.variant === "yellow") rules += ' gN15';
        else if (props.variant === "orange") rules += ' gQ15';
        else if (props.variant === "red") rules += ' gB15';
        else if (props.variant === "gray") rules += ' g615';
        else if (props.variant === "negative") rules += ' gB15';
        else if (props.variant === "notice") rules += ' gQ15';
        else if (props.variant === "positive") rules += ' g115';
        else if (props.variant === "neutral") rules += ' g615';
        else if (props.variant === "informative") rules += ' g215';
        else if (props.variant === "accent") rules += ' g215';
    }
    rules += ' _jf15';
    rules += ' _kJ8iPYd15';
    rules += ' hXMFGYc15';
    rules += ' mc15';
    rules += ' lc15';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS15';
        else if (props.variant === "notice") rules += ' i9VrKkd15';
        else if (props.variant === "positive") rules += ' ip17Jm15';
        else if (props.variant === "neutral") rules += ' i0ruhAb15';
        else if (props.variant === "informative") rules += ' iG1ze4d15';
        else if (props.variant === "accent") rules += ' iG1ze4d15';
        else rules += ' iA15';
    } else rules += ' iA15';
    rules += ' -_8sjo0b-t5ZbAob15';
    if (props.size === "XL") rules += ' -M_-MBaYFfc15';
    else if (props.size === "L") rules += ' -M_-M3JjxG15';
    else if (props.size === "S") rules += ' -M_-MCe2o8c15';
    else if (props.size === "XS") rules += ' -M_-MifsFYc15';
    else rules += ' -M_-M4dY0ec15';
    rules += ' -_k_-_kc15';
    rules += ' -h_-hc15';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG15';
                        rules += ' QAzEcG15';
                        rules += ' _Jb15';
                        rules += ' _Nc15';
                        rules += ' Pc15';
                        rules += ' _Yb15';
                        if (props.overflowMode === "wrap") rules += ' _7b15';
                        else if (props.overflowMode === "truncate") rules += ' _7c15';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja15"
                    }),
                    styles: " ZuUmpre15 FuUmpre15 I67logd15 _va15"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=Avatar.7b97958d.js.map
